<template>
    <div>
      <vue-headful
      title="Dashboard | Edit link in bio"
      description="Dashboard | Edit link in bio"
  />
  
      <div>
          <nav style="position: fixed;width: 100%;height: 71px;background: #ffffff;border-bottom: 1px solid #dde1ed;z-index: 99;">
              <div style="display: flex;align-items: center;height: 100%;justify-content: space-between;margin-left: 20px;margin-right: 20px;">
                  <router-link to="/dashboard/link-in-bio" class="btn btn-light"><i class="fa-solid fa-chevron-left mr-2"></i> Back</router-link>
                  <button v-if="!publishing_link_in_bio" @click="save_link_in_bio" class="btn btn-success">Publish</button>
                  <button v-if="publishing_link_in_bio" class="btn btn-success">Publishing...</button>
              </div>
          </nav>
  
  
  
  
  
          <!-- MOBILE SIDEBAR -->
          <div class="d-lg-none" style="position: fixed;bottom: -1px;left: 0px;background: rgb(255, 255, 255);width: -webkit-fill-available;box-shadow: rgba(170, 170, 170, 0.18) 10px 10px 10px 10px !important;z-index: 2;">
          <div v-if="tab !== ''" style="padding: 10px 10px 0 10px">
            <div class="d-flex align-items-center justify-content-between" style="border-bottom: 1px solid #e8e8e8;">
              <p v-if="tab === 'content' || tab === ''" class="display-4 mb-0">Content</p>
              <p v-if="tab === 'design'" class="display-4 mb-0">Design</p>
              <p v-if="tab === 'settings'" class="display-4 mb-0">Settings</p>
              <button @click="change_tab('')" class="btn d-flex align-items-center pt-2 pb-2 pl-2 pr-0" style="font-size: 23px;">
                <i class="fa-solid fa-square-xmark ml-1"></i>
              </button>
            </div>
            <div class="overflow-auto col-12 height-navigation-mobile_linkinbio scroll_to_last_item_sidebar_mobile" style="width: 100%;padding-top: 15px;">
      
      
      
      
            <div class="pt-2">
            <!-- PLACEHOLDER -->
            <div v-if="loading_link_in_bio">
                <div style="background: #dddddd;height: 200px;border-radius: 0.5rem;"><div class="shine200"></div></div>
                <div class="mt-3" style="background: #dddddd;height: 20px;border-radius: 0.5rem;"><div class="shine20"></div></div>
                <div class="mt-3" style="background: #dddddd;height: 20px;border-radius: 0.5rem;"><div class="shine20"></div></div>
                <div class="mt-3" style="background: #dddddd;height: 20px;border-radius: 0.5rem;"><div class="shine20"></div></div>
            </div>
            <div v-else>
              <!-- CONTENT -->
              <div v-if="tab === 'content' || tab === ''">
                <h1>Add your sections</h1>
                <p class="lead">Add the sections you want to show on your link in bio. You can change the order and edit it at any time.</p>
                <button @click="show_modal_sections" class="btn btn-lg btn-primary w-100 mb-3">
                    <i class="fa-solid fa-plus mr-2"></i> Add Section
                </button>
                <draggable v-model="sections" class="list-group" v-bind="{ handle: '.handle' }">
                    <div v-for="(section, section_index) in sections" :key="section_index" class="p-3 mb-3" :style="{border: '2px solid rgb(221, 225, 237)', borderRadius: '8px'}">
                        <div v-if="section.type === 'Profile Information'">
                            <div class="d-flex align-items-center mb-3">
                                <div class="p-2 bg-light handle" style="border-radius: 8px; width:40px; height:40px;cursor: grab;">
                                    <i class="fa-solid fa-bars" style="color: rgb(154, 154, 154); font-size: 23px; margin-left: 2px;"></i>
                                </div>
                                <p class="lead col m-0">Profile Information</p>
                            </div>
                            <div class="mb-3">
                                <p class="mb-2">Profile Image</p>
                                <div class="d-flex align-items-center">
                                    <img v-if="!section.profile_image && !logo_unique_id" src="https://logo.app/assets/img/placeholder-image.jpg" alt="Profile Image" class="rounded mr-3" width="80" height="80" style="object-fit: cover;">
                                    <img v-else-if="section.profile_image && profile_image_s3 === 'data:image'" :src="section.profile_image" alt="Profile Image" class="rounded mr-3" width="80" height="80" style="object-fit: cover;">
                                    <img v-else-if="section.profile_image && profile_image_s3 === 'needs_update'" :src="'https://logo.app/link-in-bio-profile-images/'+section.profile_image+'?'+timenow" alt="Profile Image" class="rounded mr-3" width="80" height="80" style="object-fit: cover;">
                                    <img v-else-if="section.profile_image && profile_image_s3 !== 'needs_update'" :src="'https://link-in-bio-profile-images.s3.amazonaws.com/'+section.profile_image+'?'+timenow" alt="Profile Image" class="rounded mr-3" width="80" height="80" style="object-fit: cover;">
                                    <img v-else-if="logo_unique_id && paid_svglogos_s3 === 'needs_update'" :src="'https://logo.app/paid-svglogos/'+logo_unique_id+'.svg?'+timenow" alt="Profile Image" class="rounded mr-3" width="80" height="80" style="object-fit: cover;">
                                    <img v-else-if="logo_unique_id && paid_svglogos_s3 !== 'needs_update'" :src="'https://paid-svglogos.s3.amazonaws.com/'+logo_unique_id+'.svg?'+timenow" alt="Profile Image" class="rounded mr-3" width="80" height="80" style="object-fit: cover;">
                                    <div>
                                        <div class="btn btn-blue">
                                            <label for="customFile1" class="mb-0 text-white" style="cursor:pointer;">Change Image</label>
                                            <input type="file" @change="UploadProfileImage" accept=".jpg, .jpeg, .png, .svg" name="image" id="customFile1" class="d-none">
                                        </div>
                                        <button v-if="profile_image || logo_unique_id" @click="profile_image = ''; logo_unique_id = '';" class="btn btn-danger"><i class="fa-solid fa-trash-can"></i></button>
                                    </div>
                                    <p v-if="profile_image_error" style="color: #ff0000;">{{profile_image_error}}</p>
                                </div>
                                <small class="text-muted">Recommended Size 500x500</small>
                                <div v-if="logos !== null && logos.length > 0">
                                    <p class="mb-2">Or choose profile image from your logos</p>
                                    <button @click="show_modal_logo" class="btn btn-blue w-100">Choose from your logos</button>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12 col-md-6 mb-3 mb-md-0 pr-md-2">
                                    <p class="mb-2">Profile Title</p>
                                    <input v-model="section.profile_title" type="text" placeholder="Your name or brand name" class="form-control">
                                </div>
                                <div class="col-12 col-md-6 pl-md-2">
                                    <p class="mb-2">Description</p>
                                    <input v-model="section.description" type="text" placeholder="Brief description" class="form-control">
                                </div>
                            </div>
                        </div>
                        <div v-else-if="section.type === 'Social Icons'">
                            <div class="d-flex align-items-center mb-3">
                                <div class="p-2 bg-light handle" style="border-radius: 8px; width:40px; height:40px;cursor: grab;">
                                    <i class="fa-solid fa-bars" style="color: rgb(154, 154, 154); font-size: 23px; margin-left: 2px;"></i>
                                </div>
                                <p class="lead col m-0">Social Icons</p>
                                <div @click="deleteSection(section_index)" class="p-2 bg-light" style="border-radius: 8px;width: 40px;height: 40px;cursor: pointer;">
                                    <i class="fa-solid fa-trash-can" style="color: rgb(154, 154, 154); font-size: 23px; margin-left: 2px;"></i>
                                </div>
                            </div>
                            <div>
                                <draggable v-model="section.social_icons" class="list-group" v-bind="{ handle: '.handle_your_social_icons_'+section_index }">
                                    <div v-for="(social_icon, social_icons_index) in section.social_icons" :key="social_icons_index" class="mb-3 row align-items-center">
                                        <div class="col-auto pr-0">
                                            <div :class="'handle_your_social_icons_'+section_index" style="cursor: grab;">
                                                <i class="fa-solid fa-bars"></i>
                                            </div>
                                        </div>
                                        <div class="col form-group mb-0 pr-2">
                                            <select class="custom-select" v-model="social_icon.media">
                                            <option disabled value="">Choose Social Media</option>
                                            <option>Apple App Store</option>
                                            <option>ArtStation</option>
                                            <option>Behance</option>
                                            <option>Discord</option>
                                            <option>Facebook</option>
                                            <option>GitHub</option>
                                            <option>Google Play Store</option>
                                            <option>Instagram</option>
                                            <option>LinkedIn</option>
                                            <option>Medium</option>
                                            <option>Patreon</option>
                                            <option>Pinterest</option>
                                            <option>Reddit</option>
                                            <option>Snapchat</option>
                                            <option>TikTok</option>
                                            <option>Tumblr</option>
                                            <option>Twitch</option>
                                            <option>Twitter</option>
                                            <option>Vimeo</option>
                                            <option>Weibo</option>
                                            <option>WhatsApp</option>
                                            <option>X</option>
                                            <option>YouTube</option>
                                            <option>Email</option>
                                            <option>Globe</option>
                                            </select>
                                        </div>
                                        <div class="col pl-2">
                                            <input type="url" placeholder="https://example.com" class="form-control" v-model="social_icon.url">
                                        </div>
                                        <div class="col-12 col-md-auto pl-md-0 pt-3 pt-md-0">
                                            <button class="btn btn-danger w-100" @click="removeSocialIcon(section_index, social_icons_index)"><i class="fa-solid fa-trash-can"></i></button>
                                        </div>
                                    </div>
                                </draggable>
                                <button class="btn btn-outline-blue w-100" @click="addSocialIcon(section_index)">
                                    <i class="fa-solid fa-plus mr-2"></i> Add social icon
                                </button>
                            </div>
                        </div>
                        <div v-else-if="section.type === 'Your Links'">
                            <div class="d-flex align-items-center mb-3">
                                <div class="p-2 bg-light handle" style="border-radius: 8px; width:40px; height:40px;cursor: grab;">
                                    <i class="fa-solid fa-bars" style="color: rgb(154, 154, 154); font-size: 23px; margin-left: 2px;"></i>
                                </div>
                                <p class="lead col m-0">Your Links</p>
                                <div @click="deleteSection(section_index)" class="p-2 bg-light" style="border-radius: 8px;width: 40px;height: 40px;cursor: pointer;">
                                    <i class="fa-solid fa-trash-can" style="color: rgb(154, 154, 154); font-size: 23px; margin-left: 2px;"></i>
                                </div>
                            </div>
                            <div>
                                <draggable v-model="section.links" class="list-group" v-bind="{ handle: '.handle_your_links_'+section_index }">
                                    <div v-for="(link, links_index) in section.links" :key="links_index" class="mb-3 row align-items-center">
                                        <div class="col-auto pr-0">
                                            <div :class="'handle_your_links_'+section_index" style="cursor: grab;">
                                                <i class="fa-solid fa-bars"></i>
                                            </div>
                                        </div>
                                        <div class="col-4 form-group mb-0 pr-2">
                                            <select class="custom-select" v-model="link.media">
                                            <option disabled value="">Choose Icon</option>
                                            <option>Apple App Store</option>
                                            <option>ArtStation</option>
                                            <option>Behance</option>
                                            <option>Discord</option>
                                            <option>Facebook</option>
                                            <option>GitHub</option>
                                            <option>Google Play Store</option>
                                            <option>Instagram</option>
                                            <option>LinkedIn</option>
                                            <option>Medium</option>
                                            <option>Patreon</option>
                                            <option>Pinterest</option>
                                            <option>Reddit</option>
                                            <option>Snapchat</option>
                                            <option>TikTok</option>
                                            <option>Tumblr</option>
                                            <option>Twitch</option>
                                            <option>Twitter</option>
                                            <option>Vimeo</option>
                                            <option>Weibo</option>
                                            <option>WhatsApp</option>
                                            <option>X</option>
                                            <option>YouTube</option>
                                            <option>Email</option>
                                            <option>Globe</option>
                                            </select>
                                        </div>
                                        <div class="col pl-2">
                                            <input type="url" placeholder="Button Text" class="form-control" v-model="link.text">
                                        </div>
                                        <div class="col-12 col-md-auto pl-3 pl-md-0  pt-3 pt-md-0">
                                            <input type="url" placeholder="https://example.com" class="form-control" v-model="link.url">
                                        </div>
                                        <div class="col-12 col-md-auto pl-md-0 pt-3 pt-md-0">
                                            <button class="btn btn-danger w-100" @click="removeLink(section_index, links_index)"><i class="fa-solid fa-trash-can"></i></button>
                                        </div>
                                    </div>
                                </draggable>
                                <button class="btn btn-outline-blue w-100" @click="addLink(section_index)">
                                    <i class="fa-solid fa-plus mr-2"></i> Add Link
                                </button>
                            </div>
                        </div>
                        <div v-else-if="section.type === 'Text'">
                            <div class="d-flex align-items-center mb-3">
                                <div class="p-2 bg-light handle" style="border-radius: 8px; width:40px; height:40px;cursor: grab;">
                                    <i class="fa-solid fa-bars" style="color: rgb(154, 154, 154); font-size: 23px; margin-left: 2px;"></i>
                                </div>
                                <p class="lead col m-0">Text</p>
                                <div @click="deleteSection(section_index)" class="p-2 bg-light" style="border-radius: 8px;width: 40px;height: 40px;cursor: pointer;">
                                    <i class="fa-solid fa-trash-can" style="color: rgb(154, 154, 154); font-size: 23px; margin-left: 2px;"></i>
                                </div>
                            </div>
                            <div class="col-12 p-0">
                                <p class="mb-2">Express more about your business or yourself.</p>
                                <textarea v-model="section.text" placeholder="Share details about your business or personal story" class="form-control"></textarea>
                            </div>
                        </div>
                        <div v-else-if="section.type === 'Address'">
                            <div class="d-flex align-items-center mb-3">
                                <div class="p-2 bg-light handle" style="border-radius: 8px; width:40px; height:40px;cursor: grab;">
                                    <i class="fa-solid fa-bars" style="color: rgb(154, 154, 154); font-size: 23px; margin-left: 2px;"></i>
                                </div>
                                <p class="lead col m-0">Address</p>
                                <div @click="deleteSection(section_index)" class="p-2 bg-light" style="border-radius: 8px;width: 40px;height: 40px;cursor: pointer;">
                                    <i class="fa-solid fa-trash-can" style="color: rgb(154, 154, 154); font-size: 23px; margin-left: 2px;"></i>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12 col-md-6 mb-3 mb-md-0 pr-md-2 pb-3">
                                    <p class="mb-2">Address Line 1</p>
                                    <input v-model="section.address_line_1" type="text" placeholder="123 Main Street" class="form-control">
                                </div>
                                <div class="col-12 col-md-6 pl-md-2 pb-3">
                                    <p class="mb-2">Address Line 2</p>
                                    <input v-model="section.address_line_2" type="text" placeholder="Apt, Unit, Suite..." class="form-control">
                                </div>
                                <div class="col-12 col-md-6 mb-3 mb-md-0 pr-md-2 pb-3">
                                    <p class="mb-2">City</p>
                                    <input v-model="section.city" type="text" placeholder="San Francisco" class="form-control">
                                </div>
                                <div class="col-12 col-md-6 pl-md-2 pb-3">
                                    <p class="mb-2">State / Province</p>
                                    <input v-model="section.state_province" type="text" placeholder="California" class="form-control">
                                </div>
                                <div class="col-12 col-md-6 mb-3 mb-md-0 pr-md-2 pb-3">
                                    <p class="mb-2">ZIP / Postal code</p>
                                    <input v-model="section.zip" type="text" placeholder="12345" class="form-control">
                                </div>
                                <div class="col-12 col-md-6 pl-md-2 pb-3">
                                    <p class="mb-2">Country</p>
                                    <input v-model="section.country" type="text" placeholder="United States" class="form-control">
                                </div>
                            </div>
                        </div>
                    </div>
                </draggable>
              </div>

      
      
      
      
      
              <!-- DESIGN -->
              <div v-if="tab === 'design'">
                <div class="p-3 mb-3" style="border: 2px solid #dde1ed; border-radius: 8px;">
                  <div class="d-flex align-items-center mb-3">
                      <div class="p-2 bg-light" style="border-radius: 8px;width: 40px;height: 40px;"><i class="fa-solid fa-palette" style="color: rgb(154 154 154);font-size: 23px;margin-left: 1px;"></i></div>
                      <p class="lead col m-0">Background</p>
                  </div>
                  <div>
                      <p class="mb-2">Background color</p>
                      <div class="row">
                          <div class="col-9">
                              <input v-model="background_color" type="text" placeholder="eg. #151f42" class="form-control">
                          </div>
                          <div class="col-3 pl-0">
                              <input v-model="background_color" type="color" style="height: 100%; border: 0.1rem solid rgb(227, 236, 242); background: rgb(255, 255, 255); width: 100%;">
                          </div>
                      </div>
                  </div>
                </div>
                <div class="p-3 mb-3" style="border: 2px solid #dde1ed; border-radius: 8px;">
                  <div class="d-flex align-items-center mb-3">
                      <div class="p-2 bg-light" style="border-radius: 8px;width: 40px;height: 40px;"><i class="fa-solid fa-palette" style="color: rgb(154 154 154);font-size: 23px;margin-left: 1px;"></i></div>
                      <p class="lead col m-0">Buttons</p>
                  </div>
                  <div class="mb-3">
                      <p class="mb-2">Button color</p>
                      <div class="row">
                          <div class="col-9">
                              <input v-model="button_color" type="text" placeholder="eg. #151f42" class="form-control">
                          </div>
                          <div class="col-3 pl-0">
                              <input v-model="button_color" type="color" style="height: 100%; border: 0.1rem solid rgb(227, 236, 242); background: rgb(255, 255, 255); width: 100%;">
                          </div>
                      </div>
                  </div>
                  <div class="mb-3">
                      <p class="mb-2">Text color</p>
                      <div class="row">
                          <div class="col-9">
                              <input v-model="button_text_color" type="text" placeholder="eg. #151f42" class="form-control">
                          </div>
                          <div class="col-3 pl-0">
                              <input v-model="button_text_color" type="color" style="height: 100%; border: 0.1rem solid rgb(227, 236, 242); background: rgb(255, 255, 255); width: 100%;">
                          </div>
                      </div>
                  </div>
                  <div class="mb-3">
                      <p class="mb-2">Icon color</p>
                      <div class="row">
                          <div class="col-9">
                              <input v-model="button_icon_color" type="text" placeholder="eg. #151f42" class="form-control">
                          </div>
                          <div class="col-3 pl-0">
                              <input v-model="button_icon_color" type="color" style="height: 100%; border: 0.1rem solid rgb(227, 236, 242); background: rgb(255, 255, 255); width: 100%;">
                          </div>
                      </div>
                  </div>
                  <div class="mb-3">
                      <p class="mb-2">Shadow color</p>
                      <div class="row">
                          <div class="col-9">
                              <input v-model="button_shadow_color" type="text" placeholder="eg. #151f42" class="form-control">
                          </div>
                          <div class="col-3 pl-0">
                              <input v-model="button_shadow_color" type="color" style="height: 100%; border: 0.1rem solid rgb(227, 236, 242); background: rgb(255, 255, 255); width: 100%;">
                          </div>
                      </div>
                  </div>
                  <div class="mb-3">
                      <p class="mb-2">Button style</p>
                      <div class="row">
                          <div class="col-3">
                              <div @click="button_style = '1'" :class="{ 'selectedcontainer': button_style === '1' }" class="aumentarscale_btn" style="background:#d2d6dc;width:100%;height:30px;border-radius:5px;cursor:pointer;"></div>
                          </div>
                          <div class="col-3">
                              <div @click="button_style = '2'" :class="{ 'selectedcontainer': button_style === '2' }" class="aumentarscale_btn" style="border:1px solid #d2d6dc;background:transparent;width:100%;height:30px;border-radius:5px;cursor:pointer;"></div>
                          </div>
                          <div class="col-3">
                              <div @click="button_style = '3'" :class="{ 'selectedcontainer': button_style === '3' }" class="aumentarscale_btn" style="background:#d2d6dc;filter: drop-shadow(rgb(55, 65, 81) 0.25rem 0.25rem 0px);width:100%;height:30px;border-radius:5px;cursor:pointer;"></div>
                          </div>
                          <div class="col-3">
                              <div @click="button_style = '4'" :class="{ 'selectedcontainer': button_style === '4' }" class="aumentarscale_btn" style="background:#d2d6dc;filter: drop-shadow(rgb(55, 65, 81) 0px 0.125rem 0.125rem);width:100%;height:30px;border-radius:5px;cursor:pointer;"></div>
                          </div>
                      </div>
                  </div>
                  <div class="mb-3">
                      <p class="mb-2">Button shape</p>
                      <div class="row">
                          <div class="col-3">
                              <div @click="button_shape = '1'" :class="{ 'selectedcontainer': button_shape === '1' }" class="aumentarscale_btn" style="background:#d2d6dc;width:100%;height:30px;border-radius:5px;cursor:pointer;"></div>
                          </div>
                          <div class="col-3">
                              <div @click="button_shape = '2'" :class="{ 'selectedcontainer': button_shape === '2' }" class="aumentarscale_btn" style="background:#d2d6dc;width:100%;height:30px;cursor:pointer;"></div>
                          </div>
                          <div class="col-3">
                              <div @click="button_shape = '3'" :class="{ 'selectedcontainer': button_shape === '3' }" class="aumentarscale_btn" style="background:#d2d6dc;width:100%;height:30px;border-radius:10px;cursor:pointer;"></div>
                          </div>
                          <div class="col-3">
                              <div @click="button_shape = '4'" :class="{ 'selectedcontainer': button_shape === '4' }" class="aumentarscale_btn" style="background:#d2d6dc;width:100%;height:30px;border-radius:15px;cursor:pointer;"></div>
                          </div>
                      </div>
                  </div>
                </div>
                <div class="p-3 mb-3" style="border: 2px solid #dde1ed; border-radius: 8px;">
                  <div class="d-flex align-items-center mb-3">
                      <div class="p-2 bg-light" style="border-radius: 8px;width: 40px;height: 40px;"><i class="fa-solid fa-palette" style="color: rgb(154 154 154);font-size: 23px;margin-left: 1px;"></i></div>
                      <p class="lead col m-0">Social Icons</p>
                  </div>
                  <div>
                      <p class="mb-2">Icon color</p>
                      <div class="row">
                          <div class="col-9">
                              <input v-model="icon_color" type="text" placeholder="eg. #151f42" class="form-control">
                          </div>
                          <div class="col-3 pl-0">
                              <input v-model="icon_color" type="color" style="height: 100%; border: 0.1rem solid rgb(227, 236, 242); background: rgb(255, 255, 255); width: 100%;">
                          </div>
                      </div>
                  </div>
                </div>
                <div class="p-3 mb-3" style="border: 2px solid #dde1ed; border-radius: 8px;">
                  <div class="d-flex align-items-center mb-3">
                      <div class="p-2 bg-light" style="border-radius: 8px;width: 40px;height: 40px;"><i class="fa-solid fa-palette" style="color: rgb(154 154 154);font-size: 23px;margin-left: 1px;"></i></div>
                      <p class="lead col m-0">Fonts</p>
                  </div>
                  <div>
                      <p class="mb-2">Font color</p>
                      <div class="row">
                          <div class="col-9">
                              <input v-model="font_color" type="text" placeholder="eg. #151f42" class="form-control">
                          </div>
                          <div class="col-3 pl-0">
                              <input v-model="font_color" type="color" style="height: 100%; border: 0.1rem solid rgb(227, 236, 242); background: rgb(255, 255, 255); width: 100%;">
                          </div>
                      </div>
                  </div>
                </div>
              </div>

      
      
      
      
      
              <!-- SETTINGS -->
              <div v-if="tab === 'settings'">
                <div class="p-3 mb-3" style="border: 2px solid #dde1ed; border-radius: 8px;">
                  <div class="d-flex align-items-center mb-3">
                      <div class="p-2 bg-light" style="border-radius: 8px;width: 40px;height: 40px;"><i class="fa-solid fa-gear" style="color: rgb(154 154 154);font-size: 23px;margin-left: 1px;"></i></div>
                      <p class="lead col m-0">Settings</p>
                  </div>
                  <p>Add a name that represents you, your business, or your brand to publish your page immediately.</p>
                  <div class="input-group">
                      <span class="input-group-text" style="border-radius: 0.5rem 0px 0px 0.5rem;">brand.bio/</span>
                      <input v-model="new_username" maxlength="255" type="text" class="form-control form-control-lg p-2" placeholder="brandname" style="border-radius: 0px 0.5rem 0.5rem 0px;">
                  </div>
                  <!-- username empty -->
                  <p v-if="!new_username" class="mt-3 mb-0 text-blue">Please set the username for your link</p>
                  <!-- This username is not available. -->
                  <div v-if="username_unavailable && new_username" class="alert alert-danger border border-danger text-danger bg-white mt-3 mb-0" role="alert">
                      <i class="fa-solid fa-circle-xmark"></i> This username is not available.
                  </div>
                  <!-- This username has invalid characters. -->
                  <div v-if="username_invalid_characters && new_username" class="alert alert-danger border border-danger text-danger bg-white mt-3 mb-0" role="alert">
                      <i class="fa-solid fa-circle-xmark"></i> Username can only contain letters, numbers, hyphens, and underscores. Please remove any spaces, dots, or special characters.
                  </div>
                  <!-- Username updated successfully. -->
                  <div v-if="username_updated && new_username" class="alert alert-success border border-success text-success bg-white mt-3 mb-0" role="alert">
                      <i class="fa-solid fa-check"></i> Username updated successfully.
                  </div>
                  <!-- Username already yours. -->
                  <div v-if="username_already_yours && new_username" class="alert alert-warning border border-warning text-warning bg-white mt-3 mb-0" role="alert">
                      <i class="fa-solid fa-check"></i> Username already yours.
                  </div>
                  <!-- update button -->
                  <div class="container-sm pt-3 pb-3 px-0">
                      <button v-if="!updating_username" :disabled="!new_username" class="btn btn-success w-100" @click="update_username">
                          Update username
                      </button>
                      <button v-else class="btn btn-success w-100">
                          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" style="top: -2px;position: relative;"></span>
                      </button>
                  </div>
                </div>
                <!-- POWERED BY -->
                <div class="p-3 mb-3" style="border: 2px solid #dde1ed; border-radius: 8px;">
                  <div class="form-check form-switch m-0">
                      <input v-model="powered_by" class="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckDefault1">
                      <label class="form-check-label" for="flexSwitchCheckDefault1">Powered By</label>
                  </div>
                </div>
              </div>
            </div>
      
      
      
      
      
      
      
      
            </div>
            </div>
          </div>
          <div class="d-flex" style="white-space: nowrap;overflow: scroll;border-top: 1px solid #dfe0e6;padding: 8px;">
            <a @click="change_tab('content')" class="d-flex flex-column align-items-center p-2 col-4" :class="{ 'active-tab-sidebar-link-in-bio-mobile': tab === 'content' }" style="border-radius: 0.5rem;min-width: 80px;"><i class="fa-solid fa-a mb-2" style="color: rgb(223, 224, 230);"></i> <span class="text-center">Content</span></a>
            <a @click="change_tab('design')" class="d-flex flex-column align-items-center p-2 col-4" :class="{ 'active-tab-sidebar-link-in-bio-mobile': tab === 'design' }" style="border-radius: 0.5rem;min-width: 80px;"><i class="fa-solid fa-palette mb-2" style="color: rgb(223, 224, 230);"></i> <span class="text-center">Design</span></a>
            <a @click="change_tab('settings')" class="d-flex flex-column align-items-center p-2 col-4" :class="{ 'active-tab-sidebar-link-in-bio-mobile': tab === 'settings' }" style="border-radius: 0.5rem;min-width: 80px;"><i class="fa-solid fa-gear mb-2" style="color: rgb(223, 224, 230);"></i> <span class="text-center">Settings</span></a>
          </div>
          </div>
          <div class="sidebar-link-in-bio px-4 pt-6 d-lg-block scroll_to_last_item_sidebar" style="display:none;">
      
      
      
      
      
            <div class="pt-2">
            <!-- PLACEHOLDER -->
            <div v-if="loading_link_in_bio">
                <div style="background: #dddddd;height: 500px;border-radius: 0.5rem;"><div class="shine500"></div></div>
                <div class="mt-3" style="background: #dddddd;height: 20px;border-radius: 0.5rem;"><div class="shine20"></div></div>
                <div class="mt-3" style="background: #dddddd;height: 20px;border-radius: 0.5rem;"><div class="shine20"></div></div>
                <div class="mt-3" style="background: #dddddd;height: 20px;border-radius: 0.5rem;"><div class="shine20"></div></div>
            </div>
            <div v-else>
              <div class="nav-wrapper position-relative pt-0">
                <ul class="nav nav-pills nav-fill flex-column flex-md-row" id="tabs-link-in-bio">
                    <li class="nav-item">
                        <a @click="change_tab('content')" class="nav-link mb-sm-3 mb-md-0" :class="{ 'active-tab-sidebar-link-in-bio': tab === 'content' }">Content</a>
                    </li>
                    <li class="nav-item">
                        <a @click="change_tab('design')" class="nav-link mb-sm-3 mb-md-0" :class="{ 'active-tab-sidebar-link-in-bio': tab === 'design' }">Design</a>
                    </li>
                    <li class="nav-item">
                        <a @click="change_tab('settings')" class="nav-link mb-sm-3 mb-md-0" :class="{ 'active-tab-sidebar-link-in-bio': tab === 'settings' }">Settings</a>
                    </li>
                </ul>
              </div>
              <!-- CONTENT -->
              <div v-if="tab === 'content' || tab === ''">
                <h1>Add your sections</h1>
                <p class="lead">Add the sections you want to show on your link in bio. You can change the order and edit it at any time.</p>
                <button @click="show_modal_sections" class="btn btn-lg btn-primary w-100 mb-3">
                    <i class="fa-solid fa-plus mr-2"></i> Add Section
                </button>
                <draggable v-model="sections" class="list-group" v-bind="{ handle: '.handle' }">
                    <div v-for="(section, section_index) in sections" :key="section_index" class="p-3 mb-3" :style="{border: '2px solid rgb(221, 225, 237)', borderRadius: '8px'}">
                        <div v-if="section.type === 'Profile Information'">
                            <div class="d-flex align-items-center mb-3">
                                <div class="p-2 bg-light handle" style="border-radius: 8px; width:40px; height:40px;cursor: grab;">
                                    <i class="fa-solid fa-bars" style="color: rgb(154, 154, 154); font-size: 23px; margin-left: 2px;"></i>
                                </div>
                                <p class="lead col m-0">Profile Information</p>
                            </div>
                            <div class="mb-3">
                                <p class="mb-2">Profile Image</p>
                                <div class="d-flex align-items-center">
                                    <img v-if="!section.profile_image && !logo_unique_id" src="https://logo.app/assets/img/placeholder-image.jpg" alt="Profile Image" class="rounded mr-3" width="80" height="80" style="object-fit: cover;">
                                    <img v-else-if="section.profile_image && profile_image_s3 === 'data:image'" :src="section.profile_image" alt="Profile Image" class="rounded mr-3" width="80" height="80" style="object-fit: cover;">
                                    <img v-else-if="section.profile_image && profile_image_s3 === 'needs_update'" :src="'https://logo.app/link-in-bio-profile-images/'+section.profile_image+'?'+timenow" alt="Profile Image" class="rounded mr-3" width="80" height="80" style="object-fit: cover;">
                                    <img v-else-if="section.profile_image && profile_image_s3 !== 'needs_update'" :src="'https://link-in-bio-profile-images.s3.amazonaws.com/'+section.profile_image+'?'+timenow" alt="Profile Image" class="rounded mr-3" width="80" height="80" style="object-fit: cover;">
                                    <img v-else-if="logo_unique_id && paid_svglogos_s3 === 'needs_update'" :src="'https://logo.app/paid-svglogos/'+logo_unique_id+'.svg?'+timenow" alt="Profile Image" class="rounded mr-3" width="80" height="80" style="object-fit: cover;">
                                    <img v-else-if="logo_unique_id && paid_svglogos_s3 !== 'needs_update'" :src="'https://paid-svglogos.s3.amazonaws.com/'+logo_unique_id+'.svg?'+timenow" alt="Profile Image" class="rounded mr-3" width="80" height="80" style="object-fit: cover;">
                                    <div>
                                        <div class="btn btn-blue">
                                            <label for="customFile2" class="mb-0 text-white" style="cursor:pointer;">Change Image</label>
                                            <input type="file" @change="UploadProfileImage" accept=".jpg, .jpeg, .png, .svg" name="image" id="customFile2" class="d-none">
                                        </div>
                                        <button v-if="profile_image || logo_unique_id" @click="profile_image = ''; logo_unique_id = '';" class="btn btn-danger"><i class="fa-solid fa-trash-can"></i></button>
                                    </div>
                                    <p v-if="profile_image_error" style="color: #ff0000;">{{profile_image_error}}</p>
                                </div>
                                <small class="text-muted">Recommended Size 500x500</small>
                                <div v-if="logos !== null && logos.length > 0">
                                    <p class="mb-2">Or choose profile image from your logos</p>
                                    <button @click="show_modal_logo" class="btn btn-blue w-100">Choose from your logos</button>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12 col-md-6 mb-3 mb-md-0 pr-md-2">
                                    <p class="mb-2">Profile Title</p>
                                    <input v-model="section.profile_title" type="text" placeholder="Your name or brand name" class="form-control">
                                </div>
                                <div class="col-12 col-md-6 pl-md-2">
                                    <p class="mb-2">Description</p>
                                    <input v-model="section.description" type="text" placeholder="Brief description" class="form-control">
                                </div>
                            </div>
                        </div>
                        <div v-else-if="section.type === 'Social Icons'">
                            <div class="d-flex align-items-center mb-3">
                                <div class="p-2 bg-light handle" style="border-radius: 8px; width:40px; height:40px;cursor: grab;">
                                    <i class="fa-solid fa-bars" style="color: rgb(154, 154, 154); font-size: 23px; margin-left: 2px;"></i>
                                </div>
                                <p class="lead col m-0">Social Icons</p>
                                <div @click="deleteSection(section_index)" class="p-2 bg-light" style="border-radius: 8px;width: 40px;height: 40px;cursor: pointer;">
                                    <i class="fa-solid fa-trash-can" style="color: rgb(154, 154, 154); font-size: 23px; margin-left: 2px;"></i>
                                </div>
                            </div>
                            <div>
                                <draggable v-model="section.social_icons" class="list-group" v-bind="{ handle: '.handle_your_social_icons_'+section_index }">
                                    <div v-for="(social_icon, social_icons_index) in section.social_icons" :key="social_icons_index" class="mb-3 row align-items-center">
                                        <div class="col-auto pr-0">
                                            <div :class="'handle_your_social_icons_'+section_index" style="cursor: grab;">
                                                <i class="fa-solid fa-bars"></i>
                                            </div>
                                        </div>
                                        <div class="col form-group mb-0 pr-2">
                                            <select class="custom-select" v-model="social_icon.media">
                                            <option disabled value="">Choose Social Media</option>
                                            <option>Apple App Store</option>
                                            <option>ArtStation</option>
                                            <option>Behance</option>
                                            <option>Discord</option>
                                            <option>Facebook</option>
                                            <option>GitHub</option>
                                            <option>Google Play Store</option>
                                            <option>Instagram</option>
                                            <option>LinkedIn</option>
                                            <option>Medium</option>
                                            <option>Patreon</option>
                                            <option>Pinterest</option>
                                            <option>Reddit</option>
                                            <option>Snapchat</option>
                                            <option>TikTok</option>
                                            <option>Tumblr</option>
                                            <option>Twitch</option>
                                            <option>Twitter</option>
                                            <option>Vimeo</option>
                                            <option>Weibo</option>
                                            <option>WhatsApp</option>
                                            <option>X</option>
                                            <option>YouTube</option>
                                            </select>
                                        </div>
                                        <div class="col pl-2">
                                            <input type="url" placeholder="https://example.com" class="form-control" v-model="social_icon.url">
                                        </div>
                                        <div class="col-12 col-md-auto pl-md-0 pt-3 pt-md-0">
                                            <button class="btn btn-danger w-100" @click="removeSocialIcon(section_index, social_icons_index)"><i class="fa-solid fa-trash-can"></i></button>
                                        </div>
                                    </div>
                                </draggable>
                                <button class="btn btn-outline-blue w-100" @click="addSocialIcon(section_index)">
                                    <i class="fa-solid fa-plus mr-2"></i> Add social icon
                                </button>
                            </div>
                        </div>
                        <div v-else-if="section.type === 'Your Links'">
                            <div class="d-flex align-items-center mb-3">
                                <div class="p-2 bg-light handle" style="border-radius: 8px; width:40px; height:40px;cursor: grab;">
                                    <i class="fa-solid fa-bars" style="color: rgb(154, 154, 154); font-size: 23px; margin-left: 2px;"></i>
                                </div>
                                <p class="lead col m-0">Your Links</p>
                                <div @click="deleteSection(section_index)" class="p-2 bg-light" style="border-radius: 8px;width: 40px;height: 40px;cursor: pointer;">
                                    <i class="fa-solid fa-trash-can" style="color: rgb(154, 154, 154); font-size: 23px; margin-left: 2px;"></i>
                                </div>
                            </div>
                            <div>
                                <draggable v-model="section.links" class="list-group" v-bind="{ handle: '.handle_your_links_'+section_index }">
                                    <div v-for="(link, links_index) in section.links" :key="links_index" class="mb-3 row align-items-center">
                                        <div class="col-auto pr-0">
                                            <div :class="'handle_your_links_'+section_index" style="cursor: grab;">
                                                <i class="fa-solid fa-bars"></i>
                                            </div>
                                        </div>
                                        <div class="col-2 form-group mb-0 pr-2">
                                            <select class="custom-select" v-model="link.media">
                                            <option disabled value="">Choose Icon</option>
                                            <option>Apple App Store</option>
                                            <option>ArtStation</option>
                                            <option>Behance</option>
                                            <option>Discord</option>
                                            <option>Facebook</option>
                                            <option>GitHub</option>
                                            <option>Google Play Store</option>
                                            <option>Instagram</option>
                                            <option>LinkedIn</option>
                                            <option>Medium</option>
                                            <option>Patreon</option>
                                            <option>Pinterest</option>
                                            <option>Reddit</option>
                                            <option>Snapchat</option>
                                            <option>TikTok</option>
                                            <option>Tumblr</option>
                                            <option>Twitch</option>
                                            <option>Twitter</option>
                                            <option>Vimeo</option>
                                            <option>Weibo</option>
                                            <option>WhatsApp</option>
                                            <option>X</option>
                                            <option>YouTube</option>
                                            <option>Email</option>
                                            <option>Globe</option>
                                            </select>
                                        </div>
                                        <div class="col pl-2">
                                            <input type="url" placeholder="Button Text" class="form-control" v-model="link.text">
                                        </div>
                                        <div class="col-12 col-md-auto pl-3 pl-md-0  pt-3 pt-md-0">
                                            <input type="url" placeholder="https://example.com" class="form-control" v-model="link.url">
                                        </div>
                                        <div class="col-12 col-md-auto pl-md-0 pt-3 pt-md-0">
                                            <button class="btn btn-danger w-100" @click="removeLink(section_index, links_index)"><i class="fa-solid fa-trash-can"></i></button>
                                        </div>
                                    </div>
                                </draggable>
                                <button class="btn btn-outline-blue w-100" @click="addLink(section_index)">
                                    <i class="fa-solid fa-plus mr-2"></i> Add Link
                                </button>
                            </div>
                        </div>
                        <div v-else-if="section.type === 'Text'">
                            <div class="d-flex align-items-center mb-3">
                                <div class="p-2 bg-light handle" style="border-radius: 8px; width:40px; height:40px;cursor: grab;">
                                    <i class="fa-solid fa-bars" style="color: rgb(154, 154, 154); font-size: 23px; margin-left: 2px;"></i>
                                </div>
                                <p class="lead col m-0">Text</p>
                                <div @click="deleteSection(section_index)" class="p-2 bg-light" style="border-radius: 8px;width: 40px;height: 40px;cursor: pointer;">
                                    <i class="fa-solid fa-trash-can" style="color: rgb(154, 154, 154); font-size: 23px; margin-left: 2px;"></i>
                                </div>
                            </div>
                            <div class="col-12 p-0">
                                <p class="mb-2">Express more about your business or yourself.</p>
                                <textarea v-model="section.text" placeholder="Share details about your business or personal story" class="form-control"></textarea>
                            </div>
                        </div>
                        <div v-else-if="section.type === 'Address'">
                            <div class="d-flex align-items-center mb-3">
                                <div class="p-2 bg-light handle" style="border-radius: 8px; width:40px; height:40px;cursor: grab;">
                                    <i class="fa-solid fa-bars" style="color: rgb(154, 154, 154); font-size: 23px; margin-left: 2px;"></i>
                                </div>
                                <p class="lead col m-0">Address</p>
                                <div @click="deleteSection(section_index)" class="p-2 bg-light" style="border-radius: 8px;width: 40px;height: 40px;cursor: pointer;">
                                    <i class="fa-solid fa-trash-can" style="color: rgb(154, 154, 154); font-size: 23px; margin-left: 2px;"></i>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12 col-md-6 mb-3 mb-md-0 pr-md-2 pb-3">
                                    <p class="mb-2">Address Line 1</p>
                                    <input v-model="section.address_line_1" type="text" placeholder="123 Main Street" class="form-control">
                                </div>
                                <div class="col-12 col-md-6 pl-md-2 pb-3">
                                    <p class="mb-2">Address Line 2</p>
                                    <input v-model="section.address_line_2" type="text" placeholder="Apt, Unit, Suite..." class="form-control">
                                </div>
                                <div class="col-12 col-md-6 mb-3 mb-md-0 pr-md-2 pb-3">
                                    <p class="mb-2">City</p>
                                    <input v-model="section.city" type="text" placeholder="San Francisco" class="form-control">
                                </div>
                                <div class="col-12 col-md-6 pl-md-2 pb-3">
                                    <p class="mb-2">State / Province</p>
                                    <input v-model="section.state_province" type="text" placeholder="California" class="form-control">
                                </div>
                                <div class="col-12 col-md-6 mb-3 mb-md-0 pr-md-2 pb-3">
                                    <p class="mb-2">ZIP / Postal code</p>
                                    <input v-model="section.zip" type="text" placeholder="12345" class="form-control">
                                </div>
                                <div class="col-12 col-md-6 pl-md-2 pb-3">
                                    <p class="mb-2">Country</p>
                                    <input v-model="section.country" type="text" placeholder="United States" class="form-control">
                                </div>
                            </div>
                        </div>
                    </div>
                </draggable>
              </div>

      
      
      
      
      
              <!-- DESIGN -->
              <div v-if="tab === 'design'">
                <div class="p-3 mb-3" style="border: 2px solid #dde1ed; border-radius: 8px;">
                  <div class="d-flex align-items-center mb-3">
                      <div class="p-2 bg-light" style="border-radius: 8px;width: 40px;height: 40px;"><i class="fa-solid fa-palette" style="color: rgb(154 154 154);font-size: 23px;margin-left: 1px;"></i></div>
                      <p class="lead col m-0">Background</p>
                  </div>
                  <div>
                      <p class="mb-2">Background color</p>
                      <div class="row">
                          <div class="col-9">
                              <input v-model="background_color" type="text" placeholder="eg. #151f42" class="form-control">
                          </div>
                          <div class="col-3 pl-0">
                              <input v-model="background_color" type="color" style="height: 100%; border: 0.1rem solid rgb(227, 236, 242); background: rgb(255, 255, 255); width: 100%;">
                          </div>
                      </div>
                  </div>
                </div>
                <div class="p-3 mb-3" style="border: 2px solid #dde1ed; border-radius: 8px;">
                  <div class="d-flex align-items-center mb-3">
                      <div class="p-2 bg-light" style="border-radius: 8px;width: 40px;height: 40px;"><i class="fa-solid fa-palette" style="color: rgb(154 154 154);font-size: 23px;margin-left: 1px;"></i></div>
                      <p class="lead col m-0">Buttons</p>
                  </div>
                  <div class="mb-3">
                      <p class="mb-2">Button color</p>
                      <div class="row">
                          <div class="col-9">
                              <input v-model="button_color" type="text" placeholder="eg. #151f42" class="form-control">
                          </div>
                          <div class="col-3 pl-0">
                              <input v-model="button_color" type="color" style="height: 100%; border: 0.1rem solid rgb(227, 236, 242); background: rgb(255, 255, 255); width: 100%;">
                          </div>
                      </div>
                  </div>
                  <div class="mb-3">
                      <p class="mb-2">Text color</p>
                      <div class="row">
                          <div class="col-9">
                              <input v-model="button_text_color" type="text" placeholder="eg. #151f42" class="form-control">
                          </div>
                          <div class="col-3 pl-0">
                              <input v-model="button_text_color" type="color" style="height: 100%; border: 0.1rem solid rgb(227, 236, 242); background: rgb(255, 255, 255); width: 100%;">
                          </div>
                      </div>
                  </div>
                  <div class="mb-3">
                      <p class="mb-2">Icon color</p>
                      <div class="row">
                          <div class="col-9">
                              <input v-model="button_icon_color" type="text" placeholder="eg. #151f42" class="form-control">
                          </div>
                          <div class="col-3 pl-0">
                              <input v-model="button_icon_color" type="color" style="height: 100%; border: 0.1rem solid rgb(227, 236, 242); background: rgb(255, 255, 255); width: 100%;">
                          </div>
                      </div>
                  </div>
                  <div class="mb-3">
                      <p class="mb-2">Shadow color</p>
                      <div class="row">
                          <div class="col-9">
                              <input v-model="button_shadow_color" type="text" placeholder="eg. #151f42" class="form-control">
                          </div>
                          <div class="col-3 pl-0">
                              <input v-model="button_shadow_color" type="color" style="height: 100%; border: 0.1rem solid rgb(227, 236, 242); background: rgb(255, 255, 255); width: 100%;">
                          </div>
                      </div>
                  </div>
                  <div class="mb-3">
                      <p class="mb-2">Button style</p>
                      <div class="row">
                          <div class="col-3">
                              <div @click="button_style = '1'" :class="{ 'selectedcontainer': button_style === '1' }" class="aumentarscale_btn" style="background:#d2d6dc;width:100%;height:30px;border-radius:5px;cursor:pointer;"></div>
                          </div>
                          <div class="col-3">
                              <div @click="button_style = '2'" :class="{ 'selectedcontainer': button_style === '2' }" class="aumentarscale_btn" style="border:1px solid #d2d6dc;background:transparent;width:100%;height:30px;border-radius:5px;cursor:pointer;"></div>
                          </div>
                          <div class="col-3">
                              <div @click="button_style = '3'" :class="{ 'selectedcontainer': button_style === '3' }" class="aumentarscale_btn" style="background:#d2d6dc;filter: drop-shadow(rgb(55, 65, 81) 0.25rem 0.25rem 0px);width:100%;height:30px;border-radius:5px;cursor:pointer;"></div>
                          </div>
                          <div class="col-3">
                              <div @click="button_style = '4'" :class="{ 'selectedcontainer': button_style === '4' }" class="aumentarscale_btn" style="background:#d2d6dc;filter: drop-shadow(rgb(55, 65, 81) 0px 0.125rem 0.125rem);width:100%;height:30px;border-radius:5px;cursor:pointer;"></div>
                          </div>
                      </div>
                  </div>
                  <div class="mb-3">
                      <p class="mb-2">Button shape</p>
                      <div class="row">
                          <div class="col-3">
                              <div @click="button_shape = '1'" :class="{ 'selectedcontainer': button_shape === '1' }" class="aumentarscale_btn" style="background:#d2d6dc;width:100%;height:30px;border-radius:5px;cursor:pointer;"></div>
                          </div>
                          <div class="col-3">
                              <div @click="button_shape = '2'" :class="{ 'selectedcontainer': button_shape === '2' }" class="aumentarscale_btn" style="background:#d2d6dc;width:100%;height:30px;cursor:pointer;"></div>
                          </div>
                          <div class="col-3">
                              <div @click="button_shape = '3'" :class="{ 'selectedcontainer': button_shape === '3' }" class="aumentarscale_btn" style="background:#d2d6dc;width:100%;height:30px;border-radius:10px;cursor:pointer;"></div>
                          </div>
                          <div class="col-3">
                              <div @click="button_shape = '4'" :class="{ 'selectedcontainer': button_shape === '4' }" class="aumentarscale_btn" style="background:#d2d6dc;width:100%;height:30px;border-radius:15px;cursor:pointer;"></div>
                          </div>
                      </div>
                  </div>
                </div>
                <div class="p-3 mb-3" style="border: 2px solid #dde1ed; border-radius: 8px;">
                  <div class="d-flex align-items-center mb-3">
                      <div class="p-2 bg-light" style="border-radius: 8px;width: 40px;height: 40px;"><i class="fa-solid fa-palette" style="color: rgb(154 154 154);font-size: 23px;margin-left: 1px;"></i></div>
                      <p class="lead col m-0">Social Icons</p>
                  </div>
                  <div>
                      <p class="mb-2">Icon color</p>
                      <div class="row">
                          <div class="col-9">
                              <input v-model="icon_color" type="text" placeholder="eg. #151f42" class="form-control">
                          </div>
                          <div class="col-3 pl-0">
                              <input v-model="icon_color" type="color" style="height: 100%; border: 0.1rem solid rgb(227, 236, 242); background: rgb(255, 255, 255); width: 100%;">
                          </div>
                      </div>
                  </div>
                </div>
                <div class="p-3 mb-3" style="border: 2px solid #dde1ed; border-radius: 8px;">
                  <div class="d-flex align-items-center mb-3">
                      <div class="p-2 bg-light" style="border-radius: 8px;width: 40px;height: 40px;"><i class="fa-solid fa-palette" style="color: rgb(154 154 154);font-size: 23px;margin-left: 1px;"></i></div>
                      <p class="lead col m-0">Fonts</p>
                  </div>
                  <div>
                      <p class="mb-2">Font color</p>
                      <div class="row">
                          <div class="col-9">
                              <input v-model="font_color" type="text" placeholder="eg. #151f42" class="form-control">
                          </div>
                          <div class="col-3 pl-0">
                              <input v-model="font_color" type="color" style="height: 100%; border: 0.1rem solid rgb(227, 236, 242); background: rgb(255, 255, 255); width: 100%;">
                          </div>
                      </div>
                  </div>
                </div>
              </div>

      
      
      
      
      
              <!-- SETTINGS -->
              <div v-if="tab === 'settings'">
                <div class="p-3 mb-3" style="border: 2px solid #dde1ed; border-radius: 8px;">
                  <div class="d-flex align-items-center mb-3">
                      <div class="p-2 bg-light" style="border-radius: 8px;width: 40px;height: 40px;"><i class="fa-solid fa-gear" style="color: rgb(154 154 154);font-size: 23px;margin-left: 1px;"></i></div>
                      <p class="lead col m-0">Settings</p>
                  </div>
                  <p>Add a name that represents you, your business, or your brand to publish your page immediately.</p>
                  <div class="input-group">
                      <span class="input-group-text" style="border-radius: 0.5rem 0px 0px 0.5rem;">brand.bio/</span>
                      <input v-model="new_username" maxlength="255" type="text" class="form-control form-control-lg p-2" placeholder="brandname" style="border-radius: 0px 0.5rem 0.5rem 0px;">
                  </div>
                  <!-- username empty -->
                  <p v-if="!new_username" class="mt-3 mb-0 text-blue">Please set the username for your link</p>
                  <!-- This username is not available. -->
                  <div v-if="username_unavailable && new_username" class="alert alert-danger border border-danger text-danger bg-white mt-3 mb-0" role="alert">
                      <i class="fa-solid fa-circle-xmark"></i> This username is not available.
                  </div>
                  <!-- This username has invalid characters. -->
                  <div v-if="username_invalid_characters && new_username" class="alert alert-danger border border-danger text-danger bg-white mt-3 mb-0" role="alert">
                      <i class="fa-solid fa-circle-xmark"></i> Username can only contain letters, numbers, hyphens, and underscores. Please remove any spaces, dots, or special characters.
                  </div>
                  <!-- Username updated successfully. -->
                  <div v-if="username_updated && new_username" class="alert alert-success border border-success text-success bg-white mt-3 mb-0" role="alert">
                      <i class="fa-solid fa-check"></i> Username updated successfully.
                  </div>
                  <!-- Username already yours. -->
                  <div v-if="username_already_yours && new_username" class="alert alert-warning border border-warning text-warning bg-white mt-3 mb-0" role="alert">
                      <i class="fa-solid fa-check"></i> Username already yours.
                  </div>
                  <!-- update button -->
                  <div class="container-sm pt-3 pb-3 px-0">
                      <button v-if="!updating_username" :disabled="!new_username" class="btn btn-success w-100" @click="update_username">
                          Update username
                      </button>
                      <button v-else class="btn btn-success w-100">
                          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" style="top: -2px;position: relative;"></span>
                      </button>
                  </div>
                </div>
                <!-- POWERED BY -->
                <div class="p-3 mb-3" style="border: 2px solid #dde1ed; border-radius: 8px;">
                  <div class="form-check form-switch m-0">
                      <input v-model="powered_by" class="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckDefault2">
                      <label class="form-check-label" for="flexSwitchCheckDefault2">Powered By</label>
                  </div>
                </div>
              </div>
            </div>
      
      
      
      
  
              
            </div>
        </div>  
  
  
  
  
  
  
  
  
  
          <div class="margin-espacio-del-sidebar-link-in-bio pt-6 pt-lg-0">
            <div v-if="loading_link_in_bio" class="pt-0 pt-lg-6 mb-6 ml-3 mr-3">
                <div class="pt-2">
                    <div style="background: #ffffff;height: 500px;border-radius: 0.5rem;"><div class="shine500_white"></div></div>
                    <div class="mt-3" style="background: #ffffff;height: 20px;border-radius: 0.5rem;"><div class="shine20_white"></div></div>
                    <div class="mt-3" style="background: #ffffff;height: 20px;border-radius: 0.5rem;"><div class="shine20_white"></div></div>
                    <div class="mt-3" style="background: #ffffff;height: 20px;border-radius: 0.5rem;"><div class="shine20_white"></div></div>
                </div>
            </div>
            <div v-else>
                <div class="phone-container">
                    <div class="phone">
                        <div class="phone-screen">
                            <div class="phone-content" :style="'background-color:'+background_color+';'">
                                <div class="container mt-5 mb-6">
                                    <!-- Profile Information Section -->
                                    <div v-for="(section, section_index) in sections" :key="section_index">
                                        <div v-if="section.type === 'Profile Information'" class="mt-3 mb-3">
                                            <div class="text-center">
                                                <img v-if="!section.profile_image && !logo_unique_id" src="https://logo.app/assets/img/placeholder-image.jpg" alt="Profile Image" class="rounded-circle" style="width:110px;height:110px;object-fit: cover;">
                                                <img v-else-if="section.profile_image && profile_image_s3 === 'data:image'" :src="section.profile_image" alt="Profile Image" class="rounded-circle" style="width:110px;height:110px;object-fit: cover;">
                                                <img v-else-if="section.profile_image && profile_image_s3 === 'needs_update'" :src="'https://logo.app/link-in-bio-profile-images/'+section.profile_image+'?'+timenow" alt="Profile Image" class="rounded-circle" style="width:110px;height:110px;object-fit: cover;">
                                                <img v-else-if="section.profile_image && profile_image_s3 !== 'needs_update'" :src="'https://link-in-bio-profile-images.s3.amazonaws.com/'+section.profile_image+'?'+timenow" alt="Profile Image" class="rounded-circle" style="width:110px;height:110px;object-fit: cover;">
                                                <img v-else-if="logo_unique_id && paid_svglogos_s3 === 'needs_update'" :src="'https://logo.app/paid-svglogos/'+logo_unique_id+'.svg?'+timenow" alt="Profile Image" class="rounded-circle" style="width:110px;height:110px;object-fit: cover;">
                                                <img v-else-if="logo_unique_id && paid_svglogos_s3 !== 'needs_update'" :src="'https://paid-svglogos.s3.amazonaws.com/'+logo_unique_id+'.svg?'+timenow" alt="Profile Image" class="rounded-circle" style="width:110px;height:110px;object-fit: cover;">
                                            </div>
                                            <h3 class="text-center mt-2 mb-1" :style="'color:'+font_color+';'">{{ section.profile_title }}</h3>
                                            <p class="text-center small" :style="'color:'+font_color+';'">{{ section.description }}</p>
                                        </div>

                                        <!-- Social Icons Section -->
                                        <div v-else-if="section.type === 'Social Icons'" class="d-flex justify-content-center flex-wrap mt-3 mb-3">
                                            <a v-for="(icon, index) in section.social_icons" :key="index" 
                                            :href="(icon.url.startsWith('http://') || icon.url.startsWith('https://')) 
                                            ? icon.url 
                                            : (socialMediaBaseUrls[icon.media] && icon.url.includes(socialMediaBaseUrls[icon.media].replace(/^https?:\/\//, ''))) 
                                            ? 'https://' + icon.url.replace(/^(https?:\/\/)?(www\.)?/, '') 
                                            : socialMediaBaseUrls[icon.media] + icon.url.replace(/^(https?:\/\/)?(www\.)?/, '')"
                                            target="_blank"
                                            class="btn btn-md m-1" :style="'color:'+icon_color+';border:1px solid '+icon_color+';'">
                                                <i v-if="icon.media === 'Google Play Store'" class="fa-brands fa-google-play"></i>
                                                <i v-else-if="icon.media === 'Apple App Store'" class="fa-brands fa-app-store"></i>
                                                <i v-else-if="icon.media === 'X'" class="fa-brands fa-x-twitter"></i>
                                                <i v-else :class="'fa-brands fa-'+icon.media.toLowerCase()"></i>
                                            </a>
                                        </div>

                                        <!-- Your Links Section -->
                                        <div v-else-if="section.type === 'Your Links'" class="text-center mt-3 mb-3">
                                            <a v-for="(link, index) in section.links" :key="index" 
                                            :href="(link.url.startsWith('http://') || link.url.startsWith('https://')) 
                                            ? link.url 
                                            : (socialMediaBaseUrls[link.media] && link.url.includes(socialMediaBaseUrls[link.media].replace(/^https?:\/\//, ''))) 
                                            ? 'https://' + link.url.replace(/^(https?:\/\/)?(www\.)?/, '') 
                                            : socialMediaBaseUrls[link.media] + link.url.replace(/^(https?:\/\/)?(www\.)?/, '')"
                                            target="_blank"
                                            class="btn btn-lg btn-block mb-2 d-flex flex-column align-items-center justify-content-center position-relative"
                                            :style="'color:'+button_text_color+';' +
                                            (button_shape === '1' ? 'border-radius:5px;' : '') +
                                            (button_shape === '2' ? 'border-radius:0px;' : '') +
                                            (button_shape === '3' ? 'border-radius:15px;' : '') +
                                            (button_shape === '4' ? 'border-radius:28px;' : '') +
                                            (button_style === '1' ? '' : '') + 
                                            (button_style === '2' ? 'border:1px solid '+button_color+';background:transparent;' : 'background-color:'+button_color+';') +
                                            (button_style === '3' ? 'filter:drop-shadow('+button_shadow_color+' 0.25rem 0.25rem 0px);' : '') +
                                            (button_style === '4' ? 'filter:drop-shadow('+button_shadow_color+' 0px 0.125rem 0.125rem);' : '') +
                                            'font-size: 17px; padding: 14px;'">
                                                <i v-if="link.media === 'Google Play Store'" class="fa-brands fa-google-play position-absolute" :style="'top: 16px;left: 10px;font-size: 22px;color:'+button_icon_color+';'"></i>
                                                <i v-else-if="link.media === 'Apple App Store'" class="fa-brands fa-app-store position-absolute" :style="'top: 16px;left: 10px;font-size: 22px;color:'+button_icon_color+';'"></i>
                                                <i v-else-if="link.media === 'X'" class="fa-brands fa-x-twitter position-absolute" :style="'top: 16px;left: 10px;font-size: 22px;color:'+button_icon_color+';'"></i>
                                                <i v-else-if="link.media === 'Email'" class="fa-solid fa-envelope position-absolute" :style="'top: 16px;left: 10px;font-size: 22px;color:'+button_icon_color+';'"></i>
                                                <i v-else-if="link.media === 'Globe'" class="fa-solid fa-globe position-absolute" :style="'top: 16px;left: 10px;font-size: 22px;color:'+button_icon_color+';'"></i>
                                                <i v-else :class="'fa-brands fa-'+link.media.toLowerCase()+' position-absolute'" :style="'top: 16px;left: 10px;font-size: 22px;color:'+button_icon_color+';'"></i>
                                                {{ link.text }}
                                            </a>
                                        </div>

                                        <!-- Text Section -->
                                        <div v-else-if="section.type === 'Text'" class="text-center mt-3 mb-3">
                                            <p v-if="section.text" class="small" :style="'color:'+font_color+';'">{{ section.text }}</p>
                                        </div>

                                        <!-- Address Section -->
                                        <div v-else-if="section.type === 'Address'" class="text-center mt-3 mb-3">
                                            <a class="small" :href="
                                            'https://www.google.com/maps/search/?api=1&amp;query=' +
                                            (section.address_line_1 ? section.address_line_1 : '') +
                                            (section.address_line_2 ? ', ' + section.address_line_2 : '') +
                                            (section.city ? ', ' + section.city : '') +
                                            (section.state_province ? ', ' + section.state_province : '') +
                                            (section.zip ? ', ' + section.zip : '') +
                                            (section.country ? ', ' + section.country : '')" 
                                            target="_blank"
                                            :style="'color:'+font_color+';'">
                                                <a v-if="section.address_line_1">
                                                    {{ section.address_line_1 }}, 
                                                </a>
                                                <a v-if="section.address_line_2">
                                                    {{ section.address_line_2 }}, 
                                                </a>
                                                <a v-if="section.city">
                                                    {{ section.city }}, 
                                                </a>
                                                <a v-if="section.state_province">
                                                    {{ section.state_province }}, 
                                                </a>
                                                <a v-if="section.zip">
                                                    {{ section.zip }}, 
                                                </a>
                                                <a v-if="section.country">
                                                    {{ section.country }}, 
                                                </a>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="poweredByYesOrNo === 'yes'" 
                                class="powered-by" 
                                :style="button_style === '2' 
                                        ? 'position: sticky; bottom: 0; left: 0; width: 100%; text-align: center; background-color: '+background_color+'; color: '+button_text_color+'; padding: 10px; border: 1px solid '+button_color+';' 
                                        : 'position: sticky; bottom: 0; left: 0; width: 100%; text-align: center; background-color: '+button_color+'; color: '+button_text_color+'; padding: 10px;'">
                                Powered by <a href="https://brand.bio" target="_blank" :style="'color:'+button_text_color+';'">Brand.Bio</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
          </div>
  
  
  
  
  
  
  
  
  
  
  
      
    </div>
  
    <!-- MODAL TEMPLATE -->
    <div v-if="modal_sections" class="modal" style="display: block !important; background: rgba(147, 152, 165, 0.35); overflow: auto;">
        <div v-click-outside="hide_modal_sections" class="modal-dialog modal-dialog-centered" style="max-width: 800px;">
            <div class="modal-content">
            <div class="modal-header w-100">
                <p class="lead mb-0">Choose which section to add</p>
                <button @click="hide_modal_sections" type="button" class="close ml-auto" style="position: absolute; right: 21px;">
                <span>×</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-12 col-md-6 mb-3">
                        <a @click="addSection('Social Icons')" class="btn btn-outline-light" style="width: 100%; text-align: left;">
                            <div class="d-flex justify-content-between pb-1">
                                <p class="m-0">
                                    <i class="fa-solid fa-square-share-nodes mr-2" style="font-size: 24px;color: #ed1d62;"></i>
                                    <strong style="font-size: 24px;">Social Icons</strong>
                                </p>
                            </div>
                            <p class="m-0" style="color: rgb(130, 139, 162);">Add icons with links to your social media channels.</p>
                        </a>
                    </div>
                    <div class="col-12 col-md-6 mb-3">
                        <a @click="addSection('Your Links')" class="btn btn-outline-light" style="width: 100%; text-align: left;">
                            <div class="d-flex justify-content-between pb-1">
                                <p class="m-0">
                                    <i class="fa-solid fa-link mr-2" style="font-size: 24px;color: #ed1d62;"></i>
                                    <strong style="font-size: 24px;">Your Links</strong>
                                </p>
                            </div>
                            <p class="m-0" style="color: rgb(130, 139, 162);">Include links to your important business pages.</p>
                        </a>
                    </div>
                    <div class="col-12 col-md-6 mb-3">
                        <a @click="addSection('Text')" class="btn btn-outline-light" style="width: 100%; text-align: left;">
                            <div class="d-flex justify-content-between pb-1">
                                <p class="m-0">
                                    <i class="fa-solid fa-rectangle-list mr-2" style="font-size: 24px;color: #ed1d62;"></i>
                                    <strong style="font-size: 24px;">Text</strong>
                                </p>
                            </div>
                            <p class="m-0" style="color: rgb(130, 139, 162);">Express more about your business or yourself.</p>
                        </a>
                    </div>
                    <div class="col-12 col-md-6 mb-3">
                        <a @click="addSection('Address')" class="btn btn-outline-light" style="width: 100%; text-align: left;">
                            <div class="d-flex justify-content-between pb-1">
                                <p class="m-0">
                                    <i class="fa-solid fa-location-dot mr-2" style="font-size: 24px;color: #ed1d62;"></i>
                                    <strong style="font-size: 24px;">Address</strong>
                                </p>
                            </div>
                            <p class="m-0" style="color: rgb(130, 139, 162);">Detailed information about where your business is located.</p>
                        </a>
                    </div>
                </div>
            </div>
            </div>
        </div>
    </div>
    <!-- MODAL LOGOS -->
    <div v-if="modal_logo" class="modal" style="display: block !important; background: rgba(147, 152, 165, 0.35); overflow: auto;">
        <div v-click-outside="hide_modal_logo" class="modal-dialog modal-dialog-centered" style="max-width: 800px;">
            <div class="modal-content">
            <div class="modal-header w-100">
                <p class="lead mb-0">Choose a different logo</p>
                <button @click="hide_modal_logo" type="button" class="close ml-auto" style="position: absolute; right: 21px;">
                <span>×</span>
                </button>
            </div>
            <div class="modal-body">
                <div v-if="loading_logos" style="margin: 0 auto;">
                    <center>
                        <lottie-player src="https://logo.app/lottie/logo-design-loading.json" background="transparent" speed="1" style="width:100%; height:100%; max-width: 500px; max-height: 500px;" loop autoplay></lottie-player>
                        <p class="lead">Loading...</p>
                    </center>
                </div>
                <div v-else>
                    <div v-if="logos !== null && logos.length > 0" class="row">
                        <div v-for="(logo, index) in logos" class="col-6 col-md-4 col-lg-3">
                            <div @click="update_logo(logo.unique_id, logo.paid_svglogos_s3);" class="aumentarscale_btn" :class="{ 'selectedcontainer': logo_unique_id === logo.unique_id }" style="width: 100%; margin-bottom: 20px; border-radius: 0.5rem;transition: transform 100ms, box-shadow 150ms;cursor: pointer;background: #FFFFFF;">
                                <div v-if="logo.paid_svglogos_s3 === 'needs_update'" class="logo-list-sin-borde display-logos-created" style="transition: transform 100ms ease 0s, box-shadow 150ms ease 0s;display: flex;height: auto;">
                                    <img :src="'https://logo.app/paid-svglogos/'+logo.unique_id+'.svg?'+timenow" style="width: 100%; border-radius: 5px;height: auto;">
                                </div>
                                <div v-else class="logo-list-sin-borde display-logos-created" style="transition: transform 100ms ease 0s, box-shadow 150ms ease 0s;display: flex;height: auto;">
                                    <img :src="'https://paid-svglogos.s3.amazonaws.com/'+logo.unique_id+'.svg?'+timenow" style="width: 100%; border-radius: 5px;height: auto;">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-else>
                        <p class="lead text-center">No logos created in this account.</p>
                    </div>
                </div>
            </div>
            </div>
        </div>
    </div>

    </div>
  
  </template>
  
    <script>
    import ClickOutside from 'vue-click-outside';

    export default {
      props:['propsdata'],
      data() {
        return {
          loading_link_in_bio: true,
          timenow: Date.now(),
          tab: 'content',
          unique_id: '',
          username: '',
          new_username: '',
          updating_username: false,
          username_unavailable: false,
          username_invalid_characters: false,
          username_updated: false,
          username_already_yours: false,
          sections: [],
          modal_sections: false,
          modal_logo: false,
          loading_logos: true,
          logos: [],
          logo_unique_id: '',
          paid_svglogos_s3: '',
          profile_image_error: false,
          profile_image_s3: '',
          socialMediaBaseUrls: {
            'Apple App Store': 'https://apps.apple.com/',
            ArtStation: 'https://artstation.com/',
            Behance: 'https://behance.net/',
            Discord: 'https://discord.com/',
            Facebook: 'https://facebook.com/',
            GitHub: 'https://github.com/',
            'Google Play Store': 'https://play.google.com/',
            Instagram: 'https://instagram.com/',
            LinkedIn: 'https://linkedin.com/',
            Medium: 'https://medium.com/',
            Patreon: 'https://patreon.com/',
            Pinterest: 'https://pinterest.com/',
            Reddit: 'https://reddit.com/',
            Snapchat: 'https://snapchat.com/',
            TikTok: 'https://tiktok.com/',
            Tumblr: 'https://tumblr.com/',
            Twitch: 'https://twitch.tv/',
            Twitter: 'https://twitter.com/',
            Vimeo: 'https://vimeo.com/',
            Weibo: 'https://weibo.com/',
            WhatsApp: 'https://whatsapp.com/',
            X: 'https://x.com/',
            YouTube: 'https://youtube.com/',
            Email: 'mailto:',
            Globe: 'https://'
          },
          background_color: '',
          button_color: '',
          button_text_color: '',
          button_icon_color: '',
          button_shadow_color: '',
          button_style: '',
          button_shape: '',
          icon_color: '',
          font_color: '',
          powered_by: '',
          retry_axios: 1,
          publishing_link_in_bio: false
        };
      },
      components: {
        draggable: window['vuedraggable']
      },
      computed: {
        poweredByYesOrNo() {
            if (this.powered_by) {
                return 'yes';
            } else {
                return 'no';
            }
        },
      },
      methods: {
        async load_link_in_bio(){
            // Wait until propsdata paid is populated
            while (this.propsdata[0].paid === '') {
                // Wait for 100ms before checking again
                await new Promise(resolve => setTimeout(resolve, 100));
            }
            if(this.propsdata[0].paid === 'yes'){
                axios.post('/dashboard/cargar-link-in-bio.php', {
                    unique_id: this.unique_id
                })
                .then(response => {
                    if(response.data === 'volver a intentar el axios para cargar formdata' && this.retry_axios <= 3){
                        this.retry_axios = this.retry_axios+1;
                    }
                    else if(response.data === 'Link in bio does not exist'){
                        this.$router.push('/dashboard/link-in-bio'); //redirect to link in bio
                    }
                    else{
                        this.username = response.data['username'];
                        this.new_username = response.data['username'];
                        if (Array.isArray(response.data['json_column']) && response.data['json_column'].length > 0) {
                            this.sections = response.data['json_column'];
                        } else {
                            this.sections = [ { type: 'Profile Information', profile_image: '', profile_title: '', description: '' }, { type: 'Social Icons', social_icons: [{ media: '', url: '' }] }, { type: 'Your Links', links: [{ media: '', text: '', url: '' }] } ];
                        }
                        // design
                        this.background_color = response.data['background_color'];
                        this.button_color = response.data['button_color'];
                        this.button_text_color = response.data['button_text_color'];
                        this.button_icon_color = response.data['button_icon_color'];
                        this.button_shadow_color = response.data['button_shadow_color'];
                        this.button_style = response.data['button_style'];
                        this.button_shape = response.data['button_shape'];
                        this.icon_color = response.data['icon_color'];
                        this.font_color = response.data['font_color'];
                        if(response.data['powered_by'] === 'yes'){
                            this.powered_by = true;
                        }
                        else{
                            this.powered_by = false;
                        }
                        this.profile_image_s3 = response.data['profile_image_s3'];
                        this.logo_unique_id = response.data['logo_unique_id'];
                        this.paid_svglogos_s3 = response.data['paid_svglogos_s3'];
                        this.retry_axios = 1;
                        this.loading_link_in_bio = false;
                    }
                })
                .catch(function (error) {
                console.log(error);
                });
            }
            else{
                this.$router.push('/dashboard/link-in-bio'); //redirect to link in bio
            }
        },
        change_tab(text) {
            this.tab = text;
        },
        addSocialIcon(section_index) {
            this.sections[section_index].social_icons.push({ media: '', url: '' });
        },
        removeSocialIcon(section_index, social_icons_index) {
            this.sections[section_index].social_icons.splice(social_icons_index, 1);
        },
        addLink(section_index) {
            this.sections[section_index].links.push({ media: '', text: '', url: '' });
        },
        removeLink(section_index, links_index) {
            this.sections[section_index].links.splice(links_index, 1);
        },
        show_modal_sections(){
            this.modal_sections = true;
        },
        hide_modal_sections(){
            this.modal_sections = false;
        },
        addSection(section) {
            if(section === 'Social Icons'){
                this.sections.push({ type: 'Social Icons', social_icons: [] });
            }
            else if(section === 'Your Links'){
                this.sections.push({ type: 'Your Links', links: [] });
            }
            else if(section === 'Text'){
                this.sections.push({ type: 'Text', text: '' });
            }
            else if(section === 'Address'){
                this.sections.push({ type: 'Address', address_line_1: '', address_line_2: '', city: '', state_province: '', zip: '', country: '' });
            }
            this.modal_sections = false;
            // Scroll to the bottom of the sidebar
            this.$nextTick(() => {
                if(window.innerWidth <= 991){ //sidebar mobile se esta mostrando
                    const sidebar = document.querySelector('.scroll_to_last_item_sidebar_mobile');
                    sidebar.scrollTo({ top: sidebar.scrollHeight, behavior: 'smooth' });
                }
                else{ //sidebar desktop se esta mostrando
                    const sidebar = document.querySelector('.scroll_to_last_item_sidebar');
                    sidebar.scrollTo({ top: sidebar.scrollHeight, behavior: 'smooth' });
                }
            });
        },
        deleteSection(section_index) {
            this.sections.splice(section_index, 1);
        },
        UploadProfileImage(e) {
            this.profile_image_error = '';
            const file = e.target.files[0]; // Get the first file
            let reader = new FileReader();
            if (file['size'] < 2000000) {
                reader.onloadend = (file) => {
                    var landing = reader.result;
                    // console.log(reader.result);
                    // Find the object where type is 'Profile Information'
                    let profileInfo = this.sections.find(section => section.type === 'Profile Information');
                    // Update the profile_image property if the object is found
                    if (profileInfo) {
                        profileInfo.profile_image = landing;
                    }
                    this.profile_image_s3 = 'data:image';
                    this.logo_unique_id = '';
                }
                reader.readAsDataURL(file);
            } else {
                this.profile_image_error = 'File is too big, please submit an image smaller than 2MB.';
            }
        },
        show_modal_logo(){
            this.modal_logo = true;
            if(this.logos.length === 0){
                this.load_logos();
            }
        },
        hide_modal_logo(){
            this.modal_logo = false;
        },
        update_logo(unique_id, where_is_file){
            this.logo_unique_id = unique_id;
            this.paid_svglogos_s3 = where_is_file;
            // Find the object where type is 'Profile Information'
            let profileInfo = this.sections.find(section => section.type === 'Profile Information');
            // Update the profile_image property if the object is found
            if (profileInfo) {
                profileInfo.profile_image = '';
            }
            this.profile_image_s3 = '';
            this.modal_logo = false; //close modal
        },
        load_logos(){
            axios.post('/dashboard/cargar-logos-unique-id.php', {
            })
            .then(response => {
                this.logos = response.data;
                this.loading_logos = false;
            })
            .catch(function (error) {
            console.log(error);
            });
        },
        update_username(){
            this.username_unavailable = false;
            this.username_invalid_characters = false;
            this.username_already_yours = false;
            this.username_updated = false;
            //update only if new_username is different
            if(this.username === this.new_username){
                this.username_already_yours = true;
                setTimeout(() => {
                    this.username_already_yours = false;
                }, 4000); // 4000 milliseconds = 4 second
            }
            else{
                this.updating_username = true;
                axios.post('/dashboard/update-username-link-in-bio.php', {
                    unique_id: this.unique_id,
                    new_username: this.new_username
                })
                .then(response => {
                    if(response.data === 'volver a intentar el axios para cargar formdata' && this.retry_axios <= 3){
                        this.retry_axios = this.retry_axios+1;
                        this.update_username();
                    }
                    else{
                        if(response.data === 'username unavailable'){
                            this.username_unavailable = true;
                        }
                        else if(response.data === 'username contains invalid characters'){
                            this.username_invalid_characters = true;
                        }
                        else{
                            this.username_updated = true;
                            this.username = response.data;
                            setTimeout(() => {
                                this.username_updated = false;
                            }, 4000); // 4000 milliseconds = 4 second
                        }
                        this.updating_username = false;
                        this.retry_axios = 1;
                    }
                })
                .catch(function (error) {
                console.log(error);
                });
            }
        },
        save_link_in_bio(){
            this.publishing_link_in_bio = true;
            axios.post('/dashboard/save-link-in-bio.php', {
                unique_id: this.unique_id,
                username: this.username,
                profile_image: this.profile_image,
                profile_image_s3: this.profile_image_s3,
                logo_unique_id: this.logo_unique_id,
                sections: this.sections,
                background_color: this.background_color,
                button_color: this.button_color,
                button_text_color: this.button_text_color,
                button_icon_color: this.button_icon_color,
                button_shadow_color: this.button_shadow_color,
                button_style: this.button_style,
                button_shape: this.button_shape,
                icon_color: this.icon_color,
                font_color: this.font_color,
                powered_by: this.poweredByYesOrNo
            })
            .then(response => {
                if(response.data === 'volver a intentar el axios para cargar formdata' && this.retry_axios <= 3){
                    this.retry_axios = this.retry_axios+1;
                    this.save_link_in_bio();
                }
                else{
                    this.publishing_link_in_bio = false;
                    this.retry_axios = 1;
                    this.$router.push('/dashboard/link-in-bio'); //redirect to link in bio editor
                }
            })
            .catch(function (error) {
            console.log(error);
            });
        }
      },
      watch: {
        new_username(){
            this.username_unavailable = false;
            this.username_invalid_characters = false;
        }
      },
      mounted() {
        this.unique_id = this.$route.params.link_in_bio_id;
        this.$emit('updateprops');
        this.load_link_in_bio();
        this.load_logos();
      },
    // do not forget this section
    directives: {
    ClickOutside
    }
    };
    </script>
  


// WEBPACK FOOTER //
// src/edit-link-in-bio.vue